<div [hidden]="hide" (click)="close();">
    <div mat-dialog-content class="popup-modal-content">
        <div class="row col-md-12 modal-content">{{message}}</div>
        <button type="button" class="close">
            <span style='font-size: 16px; outline: none;color: black;'>&times;</span>
        </button>
    </div>
    <div mat-dialog-actions class="popup-modal-footer mt-4">
        <span>
            <button class="btn step-btn" [mat-dialog-close]="true" (click)="getDoneFlow()">Home</button>
        </span>
        <span class="ml-2">
            <button class="btn step-btn" (click)="backToDashboard()">Support Topics</button>
        </span>
    </div>
</div>